<template>
  <div>

      <div class="row">
        <div v-if="groupConfigViewFlag & (flagActualGroupDefault == false)" class="col-xs-12 col-sm-12">
          <div class="form-group">
              <div class="col-sm-12">
                  <h4 class="font-w300 push">{{ textLabelGroupID[actualLanguage] }} : {{actualGroup.group_id.split("::").pop()}}</h4>
                  <h4 class="font-w300 push">{{ textLabelLinkedOrganization[actualLanguage] }} : {{actualGroup.rightsProviderName}}</h4>


              </div>
          </div>
        </div>
      </div>


      <div class="row"> 
        <div class="col-xs-12">

            <div v-if="groupConfigEditFlag" class="col-xs-12 items-push">
              <div v-if="navIndex.GS.length>0" class="col-sm-12 col-md-12">
                <div>
                  <h5  class="font-w200">{{ textSectionToAddGroupA[actualLanguage] }}<i class="fa fa-users fa-1x "></i>{{ textSectionToAddGroupB[actualLanguage] }}</h5>
                </div> 
              </div>

            </div>         
        </div>
      </div>


      <!-- Group Config -->
      <div v-if="groupConfigViewFlag & (flagActualGroupDefault == false)" class="block block-bordered">
        <div class="block block-themed">
          
          <div class="block-header bg-primary-dark">
                  <ul  class="block-options">

                      <li v-if="flagDisplayConfig===0">
                          <button type="button" @click="toggleDisplayConfig()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>

                      <li v-if="flagDisplayConfig">
                          <button  type="button" @click="toggleDisplayConfig()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>

                  </ul>
              <h2 class="block-title" @click="toggleDisplayConfig()"><i class="fa fa-gear fa-1x push-5-r "></i>{{ sectionLabelConfig[actualLanguage] }}</h2>
          </div>

          <div v-if="flagDisplayConfig" class="block-content">
            <div class="row">

                <div class="col-xs-12 push">
                  <h6  class="font-w200">{{ subSectionGroupOptionsConfig[actualLanguage] }}</h6>
                </div>

                <div class="col-xs-12 push">
                  <div v-for = "(groupOption ,index) in actualGroup.group_options">

                    <div  class="col-sm-12">
                      <label class="css-input switch switch-success">
                          <input @change="updateGroupOptions" type="checkbox" checked v-model="groupOption.value">
                          <span></span> {{ groupOption.displayLabel[actualLanguage] }}
                      </label>
                    </div>

                  </div>
                </div>



                <div class="col-sm-12 col-md-6">
                  <div>
                      <p><button v-if="groupConfigEditFlag" @click="saveNewGroupName()" type="button" class="btn btn-block btn-success align-left" name="button">
                        <spinner size="small" v-if="newGroupNameIsSaving"></spinner>
                        <span v-else>{{ buttonLabelModifyGroupName[actualLanguage] }}</span></button></p>
                  </div> 
                </div>

                <div class="col-sm-12 col-md-6">
                  <div v-if="flagActualGroupDefault==false">
                      <p><button v-if="groupConfigDeleteFlag" @click="deleteGroup()" type="button" class="btn btn-block btn-danger align-left" name="button">
                        <spinner size="small" v-if="groupIsDeleting"></spinner>
                        <span v-else><i class="fa fa-trash fa-1x push-5-r "></i>{{ buttonLabelDeleteGroup[actualLanguage] }}</span></button></p>
                  </div> 
                </div>

            </div>

          </div>
        </div>
      </div>



      <!-- END Group config -->





      <!-- Sharing Section -->
      <div v-if="groupConfigViewFlag & (flagActualGroupDefault == false)" class="block block-bordered">
        <div class="block block-themed">
          
          <div class="block-header bg-primary-dark">
                  <ul  class="block-options">

                      <li v-if="flagDisplaySharing===0">
                          <button type="button" @click="toggleDisplaySharing()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>

                      <li v-if="flagDisplaySharing">
                          <button  type="button" @click="toggleDisplaySharing()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>

                  </ul>
              <h2 class="block-title" @click="toggleDisplaySharing()"><i class="fa fa-share-alt fa-1x push-5-r "></i>{{ sectionLabelSharing[actualLanguage] }}</h2>
          </div>

          <div v-if="flagDisplaySharing" class="block-content">
            <div class="row">

                <div class="col-xs-12 push">
                  <h6  class="font-w200">{{ textSharingMessage[actualLanguage] }}</h6>
                </div>

                <div class="col-xs-12 push">
                  <button v-if="groupSharingEnableFlag" @click="shareEntity()" type="button" class="btn btn-block btn-success align-left" name="button">
                    <i class="fa fa-share-alt fa-1x push-5-r "></i>{{ buttonLabelShareThisGroup[actualLanguage] }}{{actualGroup.group_name}}</button>
                </div>

                <div class="col-xs-12">
                  <config-sharing-list  :sharingListData="{sharingType:'Group'}" ></config-sharing-list>
                </div>

            </div>

          </div>
        </div>
      </div>
      <!-- END Sharing Section -->





      <!-- Group Member Section -->
      <div v-if="groupConfigViewFlag & (flagActualGroupDefault == false)" class="block block-bordered">
        <div class="block block-themed">
          
          <div class="block-header bg-primary-dark">
                  <ul  class="block-options">

                      <li v-if="flagDisplayGroupMembers===0">
                          <button type="button" @click="toggleDisplayGroupMembers()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>

                      <li v-if="flagDisplayGroupMembers">
                          <button  type="button" @click="toggleDisplayGroupMembers()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>

                  </ul>
              <h2 class="block-title" @click="toggleDisplayGroupMembers()"><i class="fa fa-group fa-1x push-5-r "></i>{{ sectionLabelGroupMembers[actualLanguage] }}</h2>
          </div>

          <div v-if="flagDisplayGroupMembers" class="block-content">
            <div class="row">

                <div class="col-xs-12 push">
                  <h6  class="font-w200">{{ textGroupMembersMessage[actualLanguage] }}</h6>
                </div>

                <div  class="block-content">
                  <div class="row">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 25%;">{{ groupMembersTableColumnOrganisation[actualLanguage] }}</th>
                                    <th class="text-center" style="width: 25%;">{{ groupMembersTableColumnName[actualLanguage] }}</th>
                                    <th class="text-center" style="width: 20%;">{{ groupMembersTableColumnEmail[actualLanguage] }}</th>
                                    <th class="text-center" style="width: 12%;">{{ groupMembersTableColumnEmailEnabled[actualLanguage] }}</th>
                                    <th class="text-center" style="width: 12%;">{{ groupMembersTableColumnSMSEnabled[actualLanguage] }}</th>
                                    <th class="text-center" style="width: 5%;">{{ groupMembersTableColumnRemove[actualLanguage] }}</th>
                                </tr>
                            </thead>
                            <tbody>   
                                  <tr v-for="(groupMember,index) in actualGroup.group_members">
                                      <td  class="text-center">
                                        <p>{{groupMember.organization}}</p>
                                        
                                      </td>
                                      <td class="text-center" >
                                        <p>{{groupMember.firstName}} {{groupMember.LastName}}</p>
                                      </td>
                                      <td class="text-center">
                                          <p>{{groupMember.email}}</p>
                                      </td>
                                      <td class="text-center">
                                          <label class="css-input switch switch-success">
                                            <input @change="updateGroupMemberOptions(index)" type="checkbox" checked v-model="groupMember.memberOptions.emailEnabled">
                                            <span></span>
                                        </label>
                                      </td>
                                      <td class="text-center">
                                          <label class="css-input switch switch-success">
                                            <input @change="updateGroupMemberOptions(index)" type="checkbox" checked v-model="groupMember.memberOptions.smsEnabled">
                                            <span></span>
                                        </label>
                                      </td>
                                      <td class="text-center">
                                        <button class="btn btn-default" type="button" @click="deleteGroupMember(index)" data-toggle="tooltip" title="Retirer/Remove"><i class="fa fa-trash"></i></button>
                                      </td>
                                  </tr>
                            </tbody>
                        </table>
                    </div>
                  </div>


                  <div v-if="groupConfigEditFlag" class="block-content">
                    <div class="row">

                        <div class="col-sm-12 col-md-6">
                          <button @click="addMySelfAsMember()" type="button" class="btn btn-block btn-success align-center" name="button">
                            <spinner size="small" v-if="addMySelfToGroup"></spinner>
                            <span v-else><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonGroupAddMySelfAsMember[actualLanguage] }}</span>
                          </button>
                        </div>

                        <div class="col-sm-12 col-md-6">
                          <button @click="addOtherProfileAsMember()" type="button" class="btn btn-block btn-success align-center" name="button">
                            <spinner size="small" v-if="addAnotherUserToGroup"></spinner>
                            <span v-else><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonGroupOtherUserAsMember[actualLanguage] }}</span>
                          </button>
                        </div>

                    </div>

                  </div>


            </div>

          </div>
        </div>
      </div>

      <!-- END Group Member -->






    
  </div>

</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters,mapActions} from 'vuex'
import Spinner from '@/components/Spinner'
import ConfigSharingList from './SubComponent/ConfigSharingList'

export default {
  //props: ['bundleIndex'],
  name: 'configureBundle',
  data() {
    return {

      flagDisplayConfig: 0,
      flagDisplaySharing: 0,
      flagDisplayGroupMembers: 0,

      tempoBundle : {},
      newGroupNameIsSaving: false,
      newBundleIsSaving : false,
      addBundleIsSaving : false,
      addBundleIsSaving2 : false,
      groupIsDeleting : false,

      addMySelfToGroup : false,
      addAnotherUserToGroup : false,


      ListOfSharings:[],

      actualLanguage : "FR",
      textLabelGroupID: {FR: 'Identifiant du groupe', EN: 'Group ID'},
      textLabelLinkedOrganization: {FR: 'Organisation', EN: 'Organization'},
      labelTableTop: {FR: 'Afficher le tableau des données', EN: 'Display data table'},
      textSectionToAddGroupA:{FR: "Pour ajouter des groupes à votre arborescence (barre de navigation), vous devez revenir en arrière en sélectionnant un groupe  (", EN: 'To add new group to your arborescence, you must go back on group selection ('},
      textSectionToAddGroupB:{FR: ") ou sélectionner la section HOME de la barre du haut pour accéder au menu d'ajouts de groupe de premier niveau.", EN: ') or select HOME on top link menu to access first level group creation menu.'},
      buttonLabelModifyGroupName:{FR: "Modifier le nom du Groupe", EN: 'Modify Group name'},
      buttonLabelDeleteGroup:{FR: "Supprimer ce Groupe", EN: 'Delete this Group'},
      sectionLabelSharing:{FR: "Partages", EN: 'Sharings'},
      textSharingMessage:{FR: "Le partage de groupe est uniquement possible vers des usagers ayant accèes au portail gestionaire.", EN: 'Group sharing is only available with other manager portal users'},
      buttonLabelShareThisGroup:{FR: "Partager le groupe : ", EN: 'Share Group : '},

      sectionLabelConfig:{FR: "Configuration", EN: 'Configuration'},
      subSectionGroupOptionsConfig:{FR: "Options du groupe", EN: 'Group options'},

      sectionLabelGroupMembers:{FR: "Membres du groupe", EN: 'Group members'},
      textGroupMembersMessage:{FR: "Les membres peuvent recevoir les alertes des systèmes sous ce groupe.", EN: 'Members can receive systems alerts.'},
      groupMembersTableColumnOrganisation:{FR: "Organisation", EN: 'Organization'},
      groupMembersTableColumnName:{FR: "Nom du membre", EN: "Member's name"},
      groupMembersTableColumnEmail:{FR: "Courriel", EN: 'Email'},
      groupMembersTableColumnEmailEnabled:{FR: "Courriel activé", EN: 'Email enabled'},
      groupMembersTableColumnSMSEnabled:{FR: "SMS activé", EN: 'SMS enabled'},
      groupMembersTableColumnRemove:{FR: "Retirer", EN: 'Remove'},
      buttonGroupAddMySelfAsMember:{FR: "M'ajouter comme membre", EN: 'Add myself as member'},
      buttonGroupOtherUserAsMember:{FR: "Ajouter un autre utilisateur", EN: 'Add another user'},

      messageNewSystemNameInGroup:{FR: "Nom de votre nouveau Système à ajouter au Groupe : ", EN: 'New System name in Group :'},
      messageNewSystemNameInGroupTextBox:{FR: "Nom du système", EN: 'System Group name'},

      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},
      messageRemoveConfirmA:{FR: "Confirmer la supression du Groupe : ", EN: 'Confirm Group deletion : '},
      messageRemoveConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},



      groupConfigViewFlag : false,
      groupConfigEditFlag : false,
      groupConfigDeleteFlag : false,
      groupSharingEnableFlag : false,

      flagActualGroupDefault : true,

    }
  },
  components: {
    Spinner,
    ConfigSharingList
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualGroup','actualBundle','navIndex','parentContainer']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  watch: {
    actualBundle(){
        this.reloadTempoBundle()
    },


    },  
  methods: {
    ...mapActions('overlayStore', ['showModal']),

    reloadTempoBundle(){
        this.tempoBundle = JSON.parse(JSON.stringify(this.actualBundle))
    },


    toggleDisplayConfig(){
      this.flagDisplayConfig = ~this.flagDisplayConfig
    },

   toggleDisplaySharing(){
      this.readGroupSharings()
      this.flagDisplaySharing = ~this.flagDisplaySharing
    },

    toggleDisplayGroupMembers(){
      this.flagDisplayGroupMembers = ~this.flagDisplayGroupMembers
    },

    toUsername(email) {
      var email2 = email.replace('.', '-dot-')
      email = email2.replace('.', '-dot-')
      email2 = email.replace('.', '-dot-')
      return email2.replace('@', '-at-')
    },

    saveNewGroupName(){
        if (this.actualLanguage == "FR"){
          var newGroupName = prompt("Nouveau nom de Groupe usagers : ", "Nom du groupe usager");
        }else{
          var newGroupName = prompt("New User Group name", "User Group name");
        }
        if(newGroupName != null){
            this.newGroupNameIsSaving = true
            var requestData = {'postAction':'SaveNewGroupName',
                                'groupId':this.actualGroup.group_id,
                                'groupName':newGroupName}
            this.$store.dispatch('sessionStore/postGroup', requestData)
                .then((response) => {
                if(response.data.Code=='OK'){
                    this.newGroupNameIsSaving = false
                    this.$store.dispatch('sessionStore/getGroupArborescence')
                    }
                })
            }    
    },



    createNewBundleInGroup(){
        var newBundleName = prompt(this.messageNewSystemNameInGroup[this.actualLanguage]+this.actualGroup.group_name, this.messageNewSystemNameInGroupTextBox[this.actualLanguage]);

        if(newBundleName != null){
            this.newBundleIsSaving2 = true
            var requestData = {'postAction':'CreateNewBundleInGroup',
                                'bundleName':newBundleName,
                                'hostGroup':this.actualGroup.group_id}
            this.$store.dispatch('sessionStore/postGroup', requestData)
                .then((response) => {
                this.newBundleIsSaving2 = false
                if(response.data.Code=='OK'){
                    this.$store.dispatch('sessionStore/getGroupArborescence')
                    }else{ window.alert(this.messagePostFail[this.actualLanguage])}
                })
            }    
    },



    deleteGroup(){
      //console.log(this.navIndex)
      var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage]+this.actualGroup.group_name, this.messageRemoveConfirmB[this.actualLanguage]);

      if(confirmation == 'DELETE'){
          this.groupIsDeleting = true
          var hostId = this.navIndex.bundleParentId

          var requestData = {'postAction':'DeleteGroup',
                              'groupId':this.actualGroup.group_id,
                              'parentContainer':this.parentContainer,
                              'hostId':hostId}
            
          this.$store.dispatch('sessionStore/postGroup', requestData)
              .then((response) => {
              if(response.data.Code=='OK'){
                  //this.$store.dispatch('sessionStore/getGroupArborescence')
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  document.location.reload()
                  this.groupIsDeleting = false
                  }else{                     
                    window.alert(response.data.PromptMessage[this.actualLanguage])
                    this.groupIsDeleting = false}
              })
          }    
    },

    updateGroupOptions(){
      
      var requestData = {'postAction':'UpdateGroupOptions',
                          'groupId':this.actualGroup.group_id,
                          'groupOptions':this.actualGroup.group_options}
      this.$store.dispatch('sessionStore/postGroup', requestData)
          .then((response) => {
          if(response.data.Code=='OK'){
                window.alert(response.data.PromptMessage[this.actualLanguage])
              }else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
          })   
    },



    shareEntity(){
      var modalParameters = {'modalTitle':{FR: "Partage de Groupe Usager", EN: 'User Group sharing'},
                        'entityOwner':this.actualGroup.group_id,
                        'sharingType':'Group',
                        'entityId':this.actualGroup.group_id,
                        'entityReferenceName':this.actualGroup.group_name,
                        'displayAlertOptions':false,
                        'displayChannelOptions':true,
                        'displayDeviceOptions':true,
                        'displayBundleOptions':true,
                        'displayGroupOptions':true,
                        'displayUserOptions':false}

      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('config-access-rules-form')
    },


    readGroupSharings(){
      var requestData = {'postAction':'GetRuleForEntity','EntityToRead':this.actualGroup.group_id}
      this.$store.dispatch('sessionStore/postRule', requestData)
          .then((response) => {
          if(response.data.Code=='OK'){
              this.ListOfSharings = response.data.Data
              }else{ window.alert(response.data.Message[this.actualLanguage])}
          })
    },

    editSharingRulePermissions(sharingIndex){
      var modalParameters = {'ruleId':this.ListOfSharings[sharingIndex].ruleId,
                        'referenceId':this.ListOfSharings[sharingIndex].referenceId,
                        'sharingReferenceName':this.ListOfSharings[sharingIndex].sharingReferenceName,
                        'sharingGuessEmail':this.ListOfSharings[sharingIndex].guessEmail,
                        }

      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('edit-access-rules-form')
    },


    saveSharingStatus(sharingIndex,newStatus) {
        var requestData = { 'postAction':'SaveSingleRuleStatus',
                            'ruleId': this.ListOfSharings[sharingIndex].ruleId,
                            'referenceId': this.ListOfSharings[sharingIndex].referenceId,
                            'newStatus': newStatus,
                            }

        this.$store.dispatch('sessionStore/postRule', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                  window.alert(response.data.Message[this.actualLanguage])
                  this.readGroupSharings()
                }
                else{ 
                  window.alert(response.data.Message[this.actualLanguage])}
            })       
      
    },

    deleteSharing(sharingIndex){
        if (this.actualLanguage == "FR"){
          var confirmation = prompt("Supprimer le partage : "+this.ListOfSharings[sharingIndex].sharingReferenceName, "Confirmer en écrivant : DELETE");
        }else{
          var confirmation = prompt("Delete the sharing : "+this.ListOfSharings[sharingIndex].sharingReferenceName, "Confirm by writing : DELETE");
        }
        if(confirmation == 'DELETE'){
            var requestData = { 'postAction':'DeleteSingleRule',
                                'ruleId': this.ListOfSharings[sharingIndex].ruleId,
                                'referenceId': this.ListOfSharings[sharingIndex].referenceId,
                                }

            this.$store.dispatch('sessionStore/postRule', requestData)
                .then((response) => {
                if(response.data.Code=='OK'){
                      window.alert(response.data.Message[this.actualLanguage])
                      this.readGroupSharings()
                    }
                    else{ 
                      window.alert(response.data.Message[this.actualLanguage])}
                }) 
            }    
    },






    addMySelfAsMember(){
        this.addMySelfToGroup = true

        var requestData = {'postAction':'AddActualUserToGroupMember',
                            'groupId':this.actualGroup.group_id}
        this.$store.dispatch('sessionStore/postGroup', requestData)
            .then((response) => {
            this.addMySelfToGroup = false
            if(response.data.Code=='OK'){
                window.alert(response.data.PromptMessage[this.actualLanguage])
                this.$store.dispatch('sessionStore/getGroupArborescence')
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })   
    },



    addOtherProfileAsMember(){
        if (this.actualLanguage == "FR"){
          var newMemberEmail = prompt("Courriel de l'usager a ajouter comme membre : ", "@");
        }else{
          var newMemberEmail = prompt("Email of the user to add as member", "@");
        }
        if(newMemberEmail != null){
            this.addAnotherUserToGroup = true
            var requestData = {'postAction':'AddGuessUserToGroupMember',
                                'groupId':this.actualGroup.group_id,
                                'guessProfileId':this.toUsername(newMemberEmail)}
            this.$store.dispatch('sessionStore/postGroup', requestData)
                .then((response) => {
                this.addAnotherUserToGroup = false
                if(response.data.Code=='OK'){
                    window.alert(response.data.PromptMessage[this.actualLanguage])
                    this.$store.dispatch('sessionStore/getGroupArborescence')
                    }
                    else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
                })
            }    
    },



    updateGroupMemberOptions(index){
        var requestData = {'postAction':'ModifyGroupMemberOptions',
                            'groupId':this.actualGroup.group_id,
                            'profileId':this.toUsername(this.actualGroup.group_members[index].email),
                            'memberOptions':this.actualGroup.group_members[index].memberOptions}

        this.$store.dispatch('sessionStore/postGroup', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                window.alert(response.data.PromptMessage[this.actualLanguage])
                this.$store.dispatch('sessionStore/getGroupArborescence')
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })

      //console.log(this.actualGroup.group_members[index].EmailEnabled)
    },


    deleteGroupMember(index){
        if (this.actualLanguage == "FR"){
          var confirmation = prompt("Retirer le membre : "+this.actualGroup.group_members[index].email, "Confirmer en écrivant : DELETE");
        }else{
          var confirmation = prompt("Remove member : "+this.actualGroup.group_members[index].email, "Confirm by writing : DELETE");
        }
        if(confirmation == 'DELETE'){
            var requestData = { 'postAction':'RemoveGroupMember',
                                'groupId':this.actualGroup.group_id,
                                'profileIdToRemove':this.toUsername(this.actualGroup.group_members[index].email),
                                }

            this.$store.dispatch('sessionStore/postGroup', requestData)
                .then((response) => {
                if(response.data.Code=='OK'){
                      window.alert(response.data.PromptMessage[this.actualLanguage])
                      this.$store.dispatch('sessionStore/getGroupArborescence')
                    }
                    else{ 
                      window.alert(response.data.PromptMessage[this.actualLanguage])}
                }) 
            }    
    },






    findPermissionItemValue(permissionList,idToFind){
        var value = false
        for (var n = 0; n < permissionList.length; n++){
          if(permissionList[n].id == idToFind)
          {value = permissionList[n].value
          //console.log('Value found')
          }
        }
        return value
    }, 


  },
  mounted() {

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
    //console.log('-------Tempo Bundle From Config Group------')
    //this.reloadTempoBundle()
    //console.log(this.tempoBundle)

    //console.log("Actual GROUP")
    //console.log(this.actualGroup)

    this.groupConfigViewFlag = this.findPermissionItemValue(this.actualGroup.permissions.group,'groupConfigView')
    this.groupConfigEditFlag = this.findPermissionItemValue(this.actualGroup.permissions.group,'groupConfigEdit')
    this.groupConfigDeleteFlag = this.findPermissionItemValue(this.actualGroup.permissions.group,'groupConfigDelete')
    this.groupSharingEnableFlag = this.findPermissionItemValue(this.actualGroup.permissions.group,'groupSharingEnable')

    this.flagActualGroupDefault = this.actualGroup.group_id.includes('DefaultGroup')

    window.scrollTo(0, 0)
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ConfigGroup.vue?70cf0fa6